export default __webpack_public_path__ + "static/media/muse.14545a71.mp3";